<div class="p-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="card-sub-heading">
      Update the upload prescription status as
      {{ props.item.receipt.status }}?
    </div>
    <button mat-icon-button [disabled]="isLoading" (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="formSubmit()">
    <div class="row py-2">
      <div class="col-md-12">

        <mat-checkbox class="example-margin bold mb-3" (change)="onCheckChange($event)" formControlName="NotifyUsers">
          Notify Users
        </mat-checkbox>

        <div class="row p-2" *ngIf="form.value.NotifyUsers">
          <div class="col-md-12">
            <div class="d-flex row">
              <ng-container formArrayName="NotifyUsersBy">
                <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-checkbox [value]="item.value.id" formControlName="isChecked" [disabled]="item.value.disable">
                        {{ item.value.value }}
                      </mat-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!isReasonLoaded && isReasonStatus  && !hideReasonBlock">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="isReasonLoaded  && !hideReasonBlock">
      <div class="row mb-2">
        <div class="col-md-12" *ngIf="isReasonStatus && !hideReasonBlock">
          <label for="reasonList">Select Reason</label>
          <mat-form-field class="w-100">
            <mat-select formControlName="reason_id" class="form-control w-100"
              placeholder="Select reason to {{ props.item.receipt.status }}">
              <mat-option *ngFor="let item of reasonList" [value]="item.id">
                {{ item?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-message [formName]="form" [fieldName]="'reason_id'" [type]="'group'">
          </app-error-message>
        </div>

        <!-- <div class="col-md-12" *ngIf="isCourierStatus && !hideForQc" >
        <label for="courierList">Select courier</label>
        <mat-select
          formControlName="courier_id"
          class="form-control w-100"
          placeholder="Select courier to {{ props.item.receipt.status }}"
        >
          <mat-option *ngFor="let item of courierList" [value]="item.id">
            {{ item?.name }}
          </mat-option>
          <mat-option class="select-btn" (click)="openAddCourierDialog()">
            <div class="d-flex align-items-center">
              <span class="material-icons mr-2 add"> add </span> Add courier to
              {{ props.item.receipt.status }}
            </div>
          </mat-option>
        </mat-select>
        <app-error-message
          [formName]="form"
          [fieldName]="'courier_id'"
          [type]="'group'"
        >
        </app-error-message>
      </div> -->
      </div>
      <div class="row mb-2">
        <div class="col-md-12" *ngIf="isReasonStatus && showInternalNotes">
          <label for="reasonList">Notes</label>
          <textarea class="form-control height" formControlName="internal_notes"
            placeholder="Please enter notes for selected reason" rows="3"></textarea>
        </div>
      </div>
    </ng-container>
    <div class="row py-2">
      <div class="col-md-12">
      </div>
    </div>
    <ng-container *ngIf="!isMessageLoaded && form.get('message')?.value != null">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="isMessageLoaded && form.get('message')?.value != null && isPatientMessage  && !hideReasonBlock">
      <div class="row py-4" *ngIf="isCustomMessageVisible() && this.form.value.NotifyUsers">
        <div class="col-md-12">
          <mat-checkbox class="example-margin" formControlName="custom_message" [disabled]="isLoading"
            (change)="onCheckMessage($event)">Automated chat</mat-checkbox>
        </div>
      </div>
      <div class="row" *ngIf="form.get('custom_message')?.value == true">
        <div class="col-md-12">
          <div class="form-group">
            <textarea class="form-control height" formControlName="message" placeholder="Custom message enter here..."
              rows="3"></textarea>
            <mat-error class="ml-3" *ngIf="form.controls['message'].touched && form.controls['message'].hasError('required')">
              Message is required
            </mat-error>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" [disabled]="isLoading" (click)="dialogRef.close()" type="button">
          Cancel
        </button>
        <button class="custom-btn" type="submit" [disabled]="isLoading">
          Confirm
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
</div>